import type { LinkProps } from "@mui/material";
import { Link, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";
import { Link as RouterLink } from "react-router";
import useClientContext from "../../context/useClientContext";
import { getObjectPageRoute } from "../../utilities/navigationHelper";

interface Props extends LinkProps {
  objectId: string;
  objectType: string;
  entityTypeCode?: string;
}

const ObjectPageLink = ({ objectId, objectType, entityTypeCode, children, ...linkProps }: PropsWithChildren<Props>) => {
  const { clientCode } = useClientContext();

  const objectPageRoute = getObjectPageRoute(clientCode, objectId, objectType, entityTypeCode);

  if (!objectPageRoute) {
    return <Typography>{children}</Typography>;
  }

  return (
    <Link
      component={RouterLink}
      to={objectPageRoute}
      target="_blank"
      rel="noopener noreferrer"
      underline="none"
      {...linkProps}
    >
      {children}
    </Link>
  );
};

export default ObjectPageLink;
